// ------------------------------------------------------------------------------
// DocReader - 文档类型、非PDF文档的预览
// author: mudas
// created: 2025/1/2
// ------------------------------------------------------------------------------

import React, { FC, useEffect, useRef, useState } from 'react';
import DOMpurify from 'dompurify';

export interface IProps {
  data?: ArrayBuffer;
  className?: string;
  docClassName?: string;
}

const DocReader: FC<IProps> = props => {
  const { data, className, docClassName } = props;

  const reader = useRef<any>();
  const [content, setContent] = useState<string>('');

  const getReader = async () => {
    if (!reader.current) {
      reader.current = await import('mammoth/mammoth.browser.min.js');
    }
    return reader.current;
  };

  const readContent = async (value: ArrayBuffer) => {
    const reader = await getReader();
    const docxRes = await reader.convertToHtml({ arrayBuffer: value }, { includeDefaultStyleMap: true });
    const docEl = document.createElement('div');

    docEl.className = docClassName ?? '';
    docEl.innerHTML = docxRes.value;
    setContent(docEl.outerHTML);

    return docEl.outerHTML;
  };

  useEffect(() => {
    data && readContent(data);
  }, [data]);

  return content && <div className={className} dangerouslySetInnerHTML={{ __html: DOMpurify.sanitize(content) }} />;
};

export default DocReader;
